import { z } from "zod";

export const customErrorSchema = z.object({
  response: z.object({
    data: z.object({
      detail: z.string(),
    }),
  }),
});

export type CustomError = z.infer<typeof customErrorSchema>;
